module.exports = __webpack_public_path__ + "7ee3564fa4f8840e209dc33358dbe03a.svg";